export const EPG_EVENT_PLAYS = 'EPG_EVENT_PLAYS';
export const EPG_EVENT_PLAYS_CLEARING = 'EPG_EVENT_PLAYS_CLEARING';
export const EPG_EVENT_FOCUS = 'EPG_EVENT_FOCUS';
export const EPG_EVENT_FOCUS_CLEARING = 'EPG_EVENT_FOCUS_CLEARING';
